var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container-fluid question-page" }, [
      _c("div", { staticClass: "question-list" }, [
        _c("div", { staticClass: "function-title" }, [_vm._v("系統說明")]),
        _c("div", { staticClass: "function-info" }, [
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "info-title" }, [_vm._v("系統管理")]),
            _c("div", { staticClass: "info-desc" }, [
              _vm._v("設定使用者相關權限，安全控管系統"),
            ]),
          ]),
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "info-title" }, [_vm._v("招募管理")]),
            _c("div", { staticClass: "info-desc" }, [
              _vm._v(
                " 包含履歷分派、推薦、安排面談、感謝函、預聘、雇用等管理流程。 "
              ),
            ]),
          ]),
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "info-title" }, [_vm._v("招聘進度")]),
            _c("div", { staticClass: "info-desc" }, [
              _vm._v(
                " 透過搜尋功能，可迅速查找應徵者資料，並可註記或加入最愛清單。 "
              ),
            ]),
          ]),
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "info-title" }, [_vm._v("人才庫")]),
            _c("div", { staticClass: "info-desc" }, [
              _vm._v(
                " 資通電腦線上招募系統可與各人力銀行平台介接 完整建立企業人才資料庫。 "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }